import { Identity } from '@sdbn/common';
import { Transport } from '../model/transport';
import { AppServerAPI } from '@sdbn/common';
import { TransportIssuesDialogComponent } from '../component/transport-issues-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { AsyncSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransportIssuesService {

  constructor(
    private dialog: MatDialog,
    private appServerAPI: AppServerAPI) { }

  public showTransportIssues(transportId: number): AsyncSubject<void> {

    const subject = new AsyncSubject<void>();

    const identity = new Identity();
    identity.id = transportId;

    this.appServerAPI.execute<Transport>('/client/control/transport/issues', identity).subscribe(
      transport => {
        this.dialog.open(TransportIssuesDialogComponent, {
          width: '900px',
          height: '700px',
          maxHeight: '95vh',
          data: transport,
          panelClass: 'tmc-dialog-container'
        }).afterClosed().subscribe(
          result => {
            subject.next();
            subject.complete();
          }
        );
      }, error => {
        console.error('Error requesting transport details', error);
      }
    );

    return subject;
  }
}
